
    const hubspotSrc = "%VITE_HUBSPOT_SCRIPT_SRC%";
    const loadHubspot = () => {
      const hasRealKey =
        typeof hubspotSrc === "string" && hubspotSrc.trim() !== "" && hubspotSrc.indexOf("%VITE_HUBSPOT_SCRIPT_SRC%") === -1;
      if (!hasRealKey) return;
      const script = document.createElement("script");
      script.src = hubspotSrc;
      script.type = "text/javascript";
      script.async = true;
      script.defer = true;
      script.id = "hs-script-loader";
      document.head.appendChild(script);
    };
    if ("requestIdleCallback" in window) {
      // @ts-ignore
      requestIdleCallback(loadHubspot);
    } else {
      window.addEventListener("load", loadHubspot);
    }
  